<div id="fullwidth">
        <app-background-carousel></app-background-carousel>
        <app-confirm-password [email]="email" [token]="token" [create]="false"></app-confirm-password>
</div>